import { render, staticRenderFns } from "./AssetDetails.vue?vue&type=template&id=e9856b3c&"
import script from "./AssetDetails.vue?vue&type=script&lang=ts&"
export * from "./AssetDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports